module.exports = __webpack_public_path__ + "img/cc.e45d3abe.png";